import { createContext, useContext, useState, ReactNode } from "react";
import { MessagePoppup } from "../../models/MessagePoppup";
import {
  StyledMessagePoppup,
  StyledMessagePoppupList,
} from "./MessagePoppup.styled";
import { MessagePoppupComponent } from "./MessagePoppup";

type MessageContextType = {
  showMessage: (messagePoppup: MessagePoppup) => void;
};

const MessageContext = createContext<MessageContextType>({
  showMessage: () => {},
});

export const useMessage = () => useContext(MessageContext);

export const MessageProvider = ({ children }: { children: ReactNode }) => {
  const [messages, setMessages] = useState<MessagePoppup[]>([]);

  const showMessage = (messagePoppup: MessagePoppup) => {
    setMessages((prev) => [...prev, messagePoppup]);

    setTimeout(() => {
      setMessages((prev) => prev.filter((m) => m !== messagePoppup));
    }, 3000);
  };

  return (
    <MessageContext.Provider value={{ showMessage }}>
      {children}
      <StyledMessagePoppupList>
        {messages.map((msg, i) => (
          <MessagePoppupComponent messagePoppup={msg} />
        ))}
      </StyledMessagePoppupList>
    </MessageContext.Provider>
  );
};
